export const GITHUB_USER = 'Harshchafle';
export const GITHUB_API = 'https://api.github.com';

export const PERSONAL_INFO = {
  name: 'Harsh Chafle',
  email: 'chafleharsh@gmail.com',
  phone: '+91 79722 34194',
  linkedin: 'https://www.linkedin.com/in/harsh-chafle-641809292/',
  location: 'India'
};
